var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('ImageNumber',{ref:"v7"}),_c('ImageNumber',{ref:"v6"}),_c('ImageNumber',{ref:"v5"}),_c('ImageNumber',{ref:"v4"}),_c('ImageNumber',{ref:"v3"}),_c('ImageNumber',{ref:"v2"}),_c('ImageNumber',{ref:"v1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }